export default __webpack_public_path__ + "static/media/define-icon.d7c190c3.svg";